const SvgArrowDown = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 22.667 8 12h16z" />
  </svg>;
export default SvgArrowDown;